import { supabase } from "@/lib/supabase";
import { cn } from "@/lib/utils";
import type { StravaScope } from "@/types/strava.types";
import { Trans } from "@lingui/react/macro";
import posthog from "posthog-js";
import * as React from "react";
import { toast } from "sonner";

type SignInWithStravaButtonProps = {
  scope?: StravaScope[];
};
export function SignInWithStravaButton({
  scope = ["read", "activity:read", "activity:read_all"],
}: SignInWithStravaButtonProps) {
  const [loadingOAuth, setLoadingOAuth] = React.useState(false);

  async function signInWithOAuth() {
    if (loadingOAuth) return;

    posthog.capture("auth_started", {
      method: "oauth",
      provider: "strava",
    });

    setLoadingOAuth(true);

    const toastId = toast.loading(<Trans>Redirecting to Strava…</Trans>, {
      description: <Trans>Complete authentication in the next step.</Trans>,
    });

    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: "keycloak",
        options: {
          redirectTo: `${window.location.origin}`,
          scopes: scope.join(","),
        },
      });

      if (error) {
        toast.error(<Trans>Sign-in failed</Trans>, {
          id: toastId,
          description: error.message,
        });
        setLoadingOAuth(false);
      }
    } catch (err) {
      toast.error(<Trans>Unexpected error</Trans>, {
        id: toastId,
        description: err instanceof Error ? err.message : String(err),
      });
      setLoadingOAuth(false);
    }
  }

  return (
    <div className="relative bg-[#FC5200]" onClick={signInWithOAuth}>
      <img
        src="/btn_strava_connect_with_orange.png"
        alt="Sign in with Strava"
        className={cn(
          "max-h-[48px] cursor-pointer",
          loadingOAuth && "opacity-0",
        )}
      />
      {loadingOAuth && (
        <div className="absolute inset-0 flex items-center justify-center text-sm font-semibold text-white opacity-70">
          <Trans>Redirecting…</Trans>
        </div>
      )}
    </div>
  );
}
